<template>
  <Modal ref="modal" :show-footer="false" content-padding="0px" dismissible position="center">
    <template #activator="{ show }">
      <button
        type="button"
        class="inline-flex items-center gap-x-1.5 hover:text-primary-500"
        @click="show"
      >
        Roles
        <QuestionMarkCircle class="size-4 stroke-2" aria-hidden="true" />
      </button>
    </template>

    <template #header="{ hide }">
      <p class="text-primary text-lg font-semibold capitalize text-center flex gap-2 items-center">
        Roles
      </p>
      <button
        class="bg-light-neutral-500 rounded-full h-[30px] w-[30px] flex items-center justify-center"
        @click="hide"
      >
        <XIcon class="size-4 stroke-2 text-mid-neutral-500" />
      </button>
    </template>

    <template #content>
      <div>
        <table aria-describedby="roles breakdown table" class="w-full border-collapse">
          <thead class="border-b bg-light-neutral-300 w-full">
            <tr>
              <th class="px-6 py-2 text-left font-medium text-sm text-mid-neutral-500">Features</th>
              <th class="px-6 py-2 text-left font-medium text-sm text-mid-neutral-500">Admin</th>
              <th class="px-6 py-2 text-center font-medium text-sm text-mid-neutral-500">
                Reviewer
              </th>
              <th class="px-6 py-2 text-center font-medium text-sm text-mid-neutral-500">Reader</th>
            </tr>
          </thead>

          <tbody class="divide-y divide-slate-200 bg-white">
            <tr>
              <td class="px-6 py-2 font-medium">Users</td>
              <td class="px-6 py-2">Create / Deactivate</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2 font-medium">Projects</td>
              <td class="px-6 py-2">Create / Delete</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2"></td>
              <td class="px-6 py-2">View All</td>
              <td class="px-6 py-2 text-center">View Own</td>
              <td class="px-6 py-2 text-center">View Own</td>
            </tr>
            <tr>
              <td class="px-6 py-2"></td>
              <td class="px-6 py-2">Assign Users</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2 font-medium">Reviews</td>
              <td class="px-6 py-2">Create / Delete</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2 font-medium">Plan</td>
              <td class="px-6 py-2">Edit</td>
              <td class="px-6 py-2 text-center">Edit</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2"></td>
              <td class="px-6 py-2">Lock / Unlock</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2 font-medium">Execution</td>
              <td class="px-6 py-2">Edit</td>
              <td class="px-6 py-2 text-center">Edit</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2"></td>
              <td class="px-6 py-2">Lock / Unlock</td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
              <td class="px-6 py-2 text-center">
                <XCircleIcon class="w-5 h-5 mx-auto text-error-200" />
              </td>
            </tr>
            <tr>
              <td class="px-6 py-2 font-medium">Exporting</td>
              <td class="px-6 py-2">Export</td>
              <td class="px-6 py-2 text-center">Export</td>
              <td class="px-6 py-2 text-center">Export</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import XIcon from "@app/components/Icons/XIcon.vue";
import Modal from "@app/components/Global/Modal/Modal.vue";
import QuestionMarkCircle from "@app/components/Icons/QuestionMarkCircle.vue";
import { XCircleIcon } from "@heroicons/vue/24/solid";
</script>
